import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/direction/WorkspaceLogin.tsx");
